/* ============================================================
   AK INTERACTIVE 3G Bundle Builder — Loaded Dice
   Accordion AK Interactive 3rd Generation acrylic paint-set builder
   with a horizontal, swipeable row per COLOUR FAMILY (Whites & Creams,
   Greys, Blacks, Metallics, Reds, Greens, Blues, Browns & Leather,
   Sand/Buff/Earth, Skin Tones, …). Like the Pro Acryl / Turbo Dork
   builders, the whole range is pulled in ONE request from the same JSON
   view the faction/paint/eugy builders use, hitting the AK 3G bundle
   collection (the same collection the DR volume discount targets):
     /collections/ak-interactive-3g-bundle-builder-collection?view=faction-bundle
   and grouped into colour families client-side. AK 3G pots carry a
   generic colour tag (White, Grey, Red, Green, …); anything without one
   falls back to a "More AK 3G" bucket, so the whole individual-paint
   range shows.

   THE DEAL — tiered % off the whole AK 3G bundle:
       5 paints  = 5% off
       10 paints = 10% off
   A flat percentage on the running subtotal once a tier is reached,
   mirroring the Citadel / Pro Acryl / Turbo Dork builders. This EXACTLY
   matches the tiered checkout discount on the
   ak-interactive-3g-bundle-builder-collection (Dr Volume Discounts,
   non-combinable), so the widget total always agrees with the basket.
   All wording frames it as an EXTRA saving on top of Loaded Dice's
   already-reduced prices.
   (Config via data-tier1-qty/pct + data-tier2-qty/pct.)

   Loading is hardened the same way as the sibling builders: read as
   text, extract the JSON object by brace-matching, and retry with
   backoff — Shopify's storefront request protection intermittently
   404s these endpoints for a short window after page load.
   ============================================================ */
(function () {
  "use strict";
  if (window.__ldakbInit) return;
  window.__ldakbInit = true;

  // Single source collection: the AK 3G bundle-builder collection
  // (handle `ak-interactive-3g-bundle-builder-collection`) — the SAME
  // collection the DR volume discount targets, so the widget preview
  // matches checkout.
  var COLLECTION_PATH = "/collections/ak-interactive-3g-bundle-builder-collection";
  var CURRENCY = "GBP";
  var LOCALE = "en-GB";
  var MAX_PAGES = 16;                    // 484 products @ 50/page -> 10, plus headroom
  var RETRIES = [900, 2200, 4500];      // backoff before each retry (ms)

  // Colour families in display order. A pot is placed by its generic
  // colour tag. AK 3G has no curated per-brand colour tag, so only the
  // generic vocabulary is used. First family to match wins, so order =
  // priority (neutrals first, then vivid colours, then earth/skin).
  var FAMILIES = [
    { name: "Whites & Creams",  generic: ["White", "Off-White / Cream", "Ivory / Bone"] },
    { name: "Blacks",           generic: ["Black"] },
    { name: "Greys",            generic: ["Grey", "Dark Grey"] },
    { name: "Metallics",        generic: ["Silver / Steel Metallic", "Gunmetal Metallic", "Gold Metallic", "Bronze / Copper Metallic", "Metallic"] },
    { name: "Reds",             generic: ["Red", "Dark Red"] },
    { name: "Oranges",          generic: ["Orange"] },
    { name: "Yellows",          generic: ["Yellow"] },
    { name: "Greens",           generic: ["Green", "Dark Green", "Lime / Bright Green"] },
    { name: "Blues",            generic: ["Blue", "Dark Blue / Navy"] },
    { name: "Turquoise & Teal", generic: ["Turquoise / Teal", "Aqua / Cyan"] },
    { name: "Purples & Violets",generic: ["Purple", "Violet", "Lavender"] },
    { name: "Pinks & Magentas", generic: ["Pink", "Magenta"] },
    { name: "Browns & Leather", generic: ["Brown", "Dark Brown", "Rust / Oxide"] },
    { name: "Sand, Buff & Earth", generic: ["Beige", "Tan / Khaki", "Ochre"] },
    { name: "Skin Tones",       generic: ["Pale Skin", "Medium Skin", "Dark Skin", "Flesh"] },
    { name: "More AK 3G",       generic: [] }  // fallback bucket
  ];
  var FALLBACK = "More AK 3G";
  // Starter SETS are excluded — they're multi-packs, not single pots, and
  // don't belong in a "pick your pots" builder. (The source collection
  // is already individual-paints-only, but guard by tag+title too.)
  var SKIP_TAGS = ["Product Type_Starter Sets"];

  function money(cents) {
    var n = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat(LOCALE, { style: "currency", currency: CURRENCY, minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n);
    } catch (e) { return "£" + n.toFixed(2); }
  }
  function el(html) { var t = document.createElement("template"); t.innerHTML = html.trim(); return t.content.firstElementChild; }
  function esc(s) {
    return String(s == null ? "" : s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\"/g, "&quot;").replace(/'/g, "&#39;");
  }
  function fixImg(url) { if (!url) return ""; if (url.indexOf("//") === 0) return "https:" + url; return url; }
  function wait(ms) { return new Promise(function (res) { setTimeout(res, ms); }); }

  // Trim brand/range prefix, size and SKU to a clean pot name:
  //   "AK Interactive 3G - White 17ml (AK11001)"                  -> "White"
  //   "AK Interactive 3rd Gen Acrylic - German Grey 17ml (AK11025)" -> "German Grey"
  //   "AK Interactive - 3rd Gen Acrylic - Pistachio (Was Mustard) 17ml (AK11130)" -> "Pistachio (Was Mustard)"
  // The range separator is " - " (spaces both sides); colour names that
  // contain a hyphen ("Green-Brown", "Dark Green-Grey") have no spaces,
  // so they survive. Split on space+hyphen and keep the last segment.
  function shortTitle(t) {
    var s = String(t || "");
    s = s.replace(/\s*\d+\s*ml\b.*$/i, "");   // drop " 17ml (AK…)" and anything after
    var parts = s.split(/\s+-\s*/);
    if (parts.length > 1) s = parts[parts.length - 1];
    s = s.replace(/\s{2,}/g, " ").trim();
    return s || String(t || "");
  }

  function familyFor(tags) {
    tags = tags || [];
    var has = function (t) { return tags.indexOf(t) !== -1; };
    for (var i = 0; i < FAMILIES.length; i++) {
      if (FAMILIES[i].generic.some(has)) return FAMILIES[i].name;
    }
    return FALLBACK;
  }

  /* ---- Data loading ---------------------------------------- */
  function extractJson(t) {
    if (!t) return null;
    try { return JSON.parse(t); } catch (e) {}
    var s = t.indexOf("{");
    if (s === -1) return null;
    var depth = 0, inStr = false, escp = false;
    for (var i = s; i < t.length; i++) {
      var c = t.charAt(i);
      if (inStr) {
        if (escp) escp = false;
        else if (c === "\\") escp = true;
        else if (c === '"') inStr = false;
        continue;
      }
      if (c === '"') inStr = true;
      else if (c === "{") depth++;
      else if (c === "}") {
        depth--;
        if (depth === 0) {
          try { return JSON.parse(t.slice(s, i + 1)); } catch (e) { return null; }
        }
      }
    }
    return null;
  }
  function fetchPage(url) {
    return fetch(url, { credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (t) { return extractJson(t); })
      .catch(function () { return null; });
  }
  function pullAll(base, maxPages) {
    var all = [];
    function next(page) {
      var sep = base.indexOf("?") === -1 ? "?" : "&";
      return fetchPage(base + sep + "page=" + page).then(function (data) {
        if (!data || !data.products) { return { items: all, failed: page === 1 }; }
        all = all.concat(data.products);
        if (data.has_next && page < maxPages) return next(page + 1);
        return { items: all, failed: false };
      });
    }
    return next(1);
  }
  function loadAll() {
    var base = COLLECTION_PATH + "?view=faction-bundle";
    function attempt(n) {
      return pullAll(base, MAX_PAGES).then(function (res) {
        if ((res.failed || res.items.length === 0) && n < RETRIES.length) {
          return wait(RETRIES[n]).then(function () { return attempt(n + 1); });
        }
        return res.items;
      });
    }
    return attempt(0);
  }

  /* ---- Cards ------------------------------------------------ */
  function cardMarkup(p, opts) {
    opts = opts || {};
    var priceHtml = money(p.price);
    if (p.compare_at_price && p.compare_at_price > p.price) {
      priceHtml += '<span class="ldpb__was">' + money(p.compare_at_price) + "</span>";
    }
    var img = p.image
      ? '<img class="ldpb__card-img" src="' + fixImg(p.image) + '" alt="" loading="lazy" width="62" height="62">'
      : '<span class="ldpb__card-img"></span>';
    var title = esc(shortTitle(p.title));
    var titleTag = opts.anchor
      ? '<span class="ldpb__card-title">' + title + "</span>"
      : '<a class="ldpb__card-title" href="' + encodeURI(p.url || "#") + '" target="_blank" rel="noopener">' + title + "</a>";
    var flag = opts.anchor ? '<span class="ldpb__anchor-flag">This paint</span>' : "";

    var max = p.inventory && p.inventory > 0 ? p.inventory : 99;
    var startQty = opts.anchor ? 1 : 0;

    var card = el(
      '<div class="ldpb__card' + (opts.anchor ? " is-anchor is-picked" : "") + '" data-variant="' + p.variant_id + '">' +
        img +
        titleTag +
        '<div class="ldpb__card-price">' + priceHtml + "</div>" +
        flag +
        '<div class="ldpb__qty">' +
          '<button type="button" data-step="-1" aria-label="Decrease">−</button>' +
          '<input type="text" inputmode="numeric" value="' + startQty + '" aria-label="Quantity">' +
          '<button type="button" data-step="1" aria-label="Increase">+</button>' +
        "</div>" +
      "</div>"
    );
    card.__ldakb = { price: Number(p.price) || 0, qty: startQty, max: max, variant: String(p.variant_id) };
    return card;
  }

  function stripMarkup(type, count) {
    return el(
      '<div class="ldpb__type" data-type="' + esc(type) + '">' +
        '<div class="ldpb__type-head">' +
          '<h4 class="ldpb__type-title">' + esc(type) + "</h4>" +
          '<span class="ldpb__type-count">' + count + (count === 1 ? " paint" : " paints") + "</span>" +
        "</div>" +
        '<div class="ldpb__strip-wrap">' +
          '<button type="button" class="ldpb__arrow ldpb__arrow--prev" aria-label="Scroll ' + esc(type) + ' paints back"><svg viewBox="0 0 24 24" fill="none"><path d="m15 6-6 6 6 6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
          '<div class="ldpb__strip" tabindex="0"></div>' +
          '<button type="button" class="ldpb__arrow ldpb__arrow--next" aria-label="Scroll ' + esc(type) + ' paints forward"><svg viewBox="0 0 24 24" fill="none"><path d="m9 6 6 6-6 6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
        "</div>" +
      "</div>"
    );
  }

  /* ---- Calculator ------------------------------------------ */
  function tierFor(qty, cfg) {
    if (qty >= cfg.t2qty) return { pct: cfg.t2pct, need: 0, next: 0 };
    if (qty >= cfg.t1qty) return { pct: cfg.t1pct, need: 0, next: cfg.t2qty - qty };
    return { pct: 0, need: cfg.t1qty - qty, next: cfg.t1qty - qty };
  }

  function recalc(root, cfg) {
    var cards = root.querySelectorAll(".ldpb__card");
    var totalQty = 0, subtotal = 0;
    cards.forEach(function (c) {
      var s = c.__ldakb;
      totalQty += s.qty;
      subtotal += s.qty * s.price;
      c.classList.toggle("is-picked", s.qty > 0);
    });

    var tier = tierFor(totalQty, cfg);
    var saving = Math.round(subtotal * tier.pct / 100);

    var fillPct = Math.min(100, (totalQty / cfg.t2qty) * 100);
    root.querySelector(".ldfb__bar-fill").style.width = fillPct + "%";
    root.querySelectorAll(".ldfb__tick").forEach(function (t) {
      var need = parseInt(t.getAttribute("data-need"), 10);
      t.classList.toggle("is-hit", totalQty >= need);
    });

    var msg;
    if (totalQty === 0) {
      msg = "Mix any AK 3G paints — <strong>" + cfg.t1qty + " for " + cfg.t1pct + "% off</strong>, <strong>" + cfg.t2qty + " for " + cfg.t2pct + "% off</strong>.";
    } else if (tier.pct === 0) {
      msg = "Add <strong>" + tier.need + " more</strong> to unlock <strong>" + cfg.t1pct + "% off</strong> your AK 3G.";
    } else if (tier.pct === cfg.t1pct) {
      msg = "<strong>" + cfg.t1pct + "% off</strong> unlocked (" + money(saving) + " off)! Add <strong>" + tier.next + " more</strong> for <strong>" + cfg.t2pct + "% off</strong>.";
    } else {
      msg = "Top tier — <strong>" + cfg.t2pct + "% off</strong> all " + totalQty + " paints (" + money(saving) + " off). Nice one.";
    }
    root.querySelector(".ldfb__progress-msg").innerHTML = msg;

    root.querySelector("[data-ldakb-subtotal]").textContent = money(subtotal);
    var saveRow = root.querySelector(".ldfb__totals-row.is-save");
    if (saving > 0) {
      saveRow.style.display = "";
      root.querySelector("[data-ldakb-saving]").textContent = "−" + money(saving);
      saveRow.querySelector(".ldfb__save-label").textContent = "Bundle saving (" + tier.pct + "% off)";
    } else {
      saveRow.style.display = "none";
    }
    root.querySelector("[data-ldakb-total]").textContent = money(subtotal - saving);

    var addBtn = root.querySelector("[data-ldakb-add]");
    addBtn.disabled = totalQty < 1;
    var lines = totalQty === 1 ? "1 paint" : totalQty + " paints";
    addBtn.querySelector(".ldfb__add-label").textContent = "Add paints to basket (" + lines + ")";
  }

  /* ---- Add to cart ------------------------------------------ */
  function addToCart(root, cfg) {
    var items = [];
    root.querySelectorAll(".ldpb__card").forEach(function (c) {
      if (c.__ldakb.qty > 0) items.push({ id: Number(c.__ldakb.variant), quantity: c.__ldakb.qty });
    });
    if (!items.length) return;

    var btn = root.querySelector("[data-ldakb-add]");
    var err = root.querySelector(".ldfb__err");
    err.textContent = "";
    btn.classList.add("is-loading");

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j && j.description ? j.description : "Could not add to basket."); });
        return r.json();
      })
      .then(function () {
        refreshCart();
        try { window.dispatchEvent(new CustomEvent("ldakb:added", { detail: { items: items } })); } catch (e) {}
      })
      .catch(function (e) {
        err.textContent = e.message || "Sorry, something went wrong. Please try again.";
      })
      .finally(function () {
        btn.classList.remove("is-loading");
      });
  }

  function refreshCart() {
    var $ = window.jQuery;
    var cartUrl = window.cartUrl || "/cart.js";
    if ($ && typeof window.buildCart === "function") {
      $.getJSON(cartUrl, function (cart) {
        try { window.buildCart(cart, true); } catch (e) {}
      });
      document.body.classList.add("side_Drawer_open");
      return;
    }
    if (typeof window.openCartDrawer === "function") {
      try { window.openCartDrawer(); return; } catch (e) {}
    }
    window.location.href = "/cart";
  }

  /* ---- Build panel ------------------------------------------ */
  function readConfig(root) {
    var d = root.dataset;
    return {
      currentId: String(d.currentId || ""),
      currentTags: String(d.currentTags || "").split("||").filter(Boolean),
      currentTitle: String(d.currentTitle || ""),
      t1qty: parseInt(d.tier1Qty, 10) || 5,
      t1pct: parseInt(d.tier1Pct, 10) || 5,
      t2qty: parseInt(d.tier2Qty, 10) || 10,
      t2pct: parseInt(d.tier2Pct, 10) || 10,
      max: parseInt(d.max, 10) || 400
    };
  }

  function skipItem(tags, title) {
    if ((tags || []).some(function (t) { return SKIP_TAGS.indexOf(t) !== -1; })) return true;
    if (/\bstarter\s+set\b/i.test(String(title || ""))) return true;
    return false;
  }

  function buildPanel(root, cfg) {
    var wrap = root.querySelector("[data-ldakb-types]");
    var loading = wrap.querySelector(".ldfb__loading");

    var anchor = {
      variant_id: root.dataset.currentVariant,
      title: root.dataset.currentTitle,
      price: Number(root.dataset.currentPrice) || 0,
      compare_at_price: Number(root.dataset.currentCompare) || 0,
      image: root.dataset.currentImage,
      inventory: Number(root.dataset.currentInventory) || 99,
      url: null
    };
    var anchorFamily = familyFor(cfg.currentTags);
    var anchorIsSet = skipItem(cfg.currentTags, cfg.currentTitle);
    var anchorShown = anchor.variant_id && root.dataset.currentAvailable === "true" && !anchorIsSet;

    loadAll().then(function (items) {
      var seen = {};
      if (anchorShown) seen[anchor.variant_id] = 1;
      var buckets = {};
      (items || []).forEach(function (p) {
        if (!p || !p.variant_id) return;
        if (p.available !== true || p.variant_available !== true) return;
        if (String(p.id) === cfg.currentId) return;   // anchor handled separately
        if (seen[p.variant_id]) return;
        if (skipItem(p.tags, p.title)) return;         // no starter sets
        seen[p.variant_id] = 1;
        var fam = familyFor(p.tags);
        (buckets[fam] = buckets[fam] || []).push(p);
      });

      if (loading) loading.remove();

      var total = 0;
      var placed = 0;
      FAMILIES.forEach(function (F) {
        var list = buckets[F.name] || [];
        var isAnchorFam = anchorShown && F.name === anchorFamily;
        var count = Math.min(list.length, cfg.max - placed) + (isAnchorFam ? 1 : 0);
        if (count === 0) return;

        list.sort(function (a, b) { return shortTitle(a.title).localeCompare(shortTitle(b.title)); });

        var section = stripMarkup(F.name, count);
        var strip = section.querySelector(".ldpb__strip");

        if (isAnchorFam) strip.appendChild(cardMarkup(anchor, { anchor: true }));
        for (var i = 0; i < list.length && placed < cfg.max; i++) {
          strip.appendChild(cardMarkup(list[i], {}));
          placed++;
        }

        var prev = section.querySelector(".ldpb__arrow--prev");
        var next = section.querySelector(".ldpb__arrow--next");
        function updateArrows() {
          prev.disabled = strip.scrollLeft <= 4;
          next.disabled = strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 4;
        }
        prev.addEventListener("click", function () { strip.scrollBy({ left: -strip.clientWidth * 0.8, behavior: "smooth" }); });
        next.addEventListener("click", function () { strip.scrollBy({ left: strip.clientWidth * 0.8, behavior: "smooth" }); });
        strip.addEventListener("scroll", updateArrows, { passive: true });
        setTimeout(updateArrows, 50);

        wrap.appendChild(section);
        total++;
      });

      if (total === 0) {
        wrap.innerHTML = '<div class="ldfb__empty">No in-stock AK 3G paints to bundle right now.</div>';
      } else {
        recalc(root, cfg);
      }
    });
  }

  /* ---- Wiring ------------------------------------------------ */
  function initRoot(root) {
    if (root.__ldakbReady) return;
    root.__ldakbReady = true;
    var cfg = readConfig(root);

    var toggle = root.querySelector(".ldfb__toggle");
    var panel = root.querySelector(".ldfb__panel");
    var loaded = false;

    toggle.addEventListener("click", function () {
      var open = toggle.getAttribute("aria-expanded") === "true";
      toggle.setAttribute("aria-expanded", String(!open));
      panel.hidden = open;
      if (!open && !loaded) { loaded = true; buildPanel(root, cfg); }
    });

    panel.addEventListener("click", function (e) {
      var btn = e.target.closest("button[data-step]");
      if (!btn) return;
      var card = btn.closest(".ldpb__card");
      var s = card.__ldakb;
      var step = Number(btn.getAttribute("data-step"));
      s.qty = Math.max(0, Math.min(s.max, s.qty + step));
      card.querySelector("input").value = s.qty;
      recalc(root, cfg);
    });
    panel.addEventListener("input", function (e) {
      if (e.target.tagName !== "INPUT") return;
      var card = e.target.closest(".ldpb__card");
      if (!card || !card.__ldakb) return;
      var s = card.__ldakb;
      var val = parseInt(e.target.value.replace(/[^0-9]/g, ""), 10);
      if (isNaN(val)) val = 0;
      s.qty = Math.max(0, Math.min(s.max, val));
      recalc(root, cfg);
    });
    panel.addEventListener("blur", function (e) {
      if (e.target.tagName === "INPUT") {
        var card = e.target.closest(".ldpb__card");
        if (card && card.__ldakb) e.target.value = card.__ldakb.qty;
      }
    }, true);

    root.querySelector("[data-ldakb-add]").addEventListener("click", function () { addToCart(root, cfg); });
  }

  function initAll() {
    document.querySelectorAll("[data-ldakb]").forEach(initRoot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();
